/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import Loader from "components/loader/Loader";
import toast from "react-hot-toast";
import { previewEmailAPI } from "Api/emailAPI";
import { consoleLog } from "helpers";

const PreviewEmailTrackModal = ({ isOpen, onClose, previewEmailFormData }) => {
  const [previewEmailData, setPreviewEmailData] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCancel = useCallback(() => {
  
    onClose();
  }, [onClose]);

  const getPreviewEmailData = useCallback(async () => {
    if (isLoading) return; 
    setIsLoading(true);  
  
    const token = localStorage.getItem("jwtToken");
    consoleLog([{ ...previewEmailFormData, isPreview: true }])
    const response = await previewEmailAPI(
      { ...previewEmailFormData, isPreview: true },
      setIsLoading,
      token
    );
  
    consoleLog(['Response from API:', response]);
  
    if (response ) {
      setPreviewEmailData(response.html);
    } else {
      toast.error("Failed to preview email: Invalid or missing 'html' data in response");
      handleCancel();
    }
  }, [handleCancel, isLoading, previewEmailFormData]);
  

  useEffect(() => {
    if (isOpen) getPreviewEmailData();
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
   
      <div
        className="fixed inset-0 z-[100] bg-[black] bg-opacity-75 transition-opacity"
        onClick={handleCancel}
      />

  
      <div className="fixed inset-0 z-[101] flex h-screen items-center justify-center overscroll-contain">
        <div className="relative z-50 mx-auto flex h-auto max-h-[90dvh] w-auto min-w-[300px] flex-col items-center justify-start overflow-auto rounded-xl bg-white p-6 shadow-xl">
          <IoMdClose
            onClick={handleCancel}
            className="absolute top-4 right-4 cursor-pointer text-gray-600 hover:text-gray-800"
            size={24}
          />

          {isLoading ? (
            <div className="flex h-[200px] w-full items-center justify-center">
              <Loader />
            </div>
          ) : (
            <div className="w-auto">
              <h2 className="mb-6 text-center text-2xl font-semibold text-gray-800">
                {"Preview"}
              </h2>
              <div
                className="prose prose-lg max-w-none"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                
                <div
              
                  dangerouslySetInnerHTML={{
                    __html: previewEmailData,
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PreviewEmailTrackModal;
